import script from "./sales_templates_new.vue?vue&type=script&setup=true&lang=js"
export * from "./sales_templates_new.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__